import type { Entity } from '@backstage/catalog-model';

import {
  createExtensionBlueprint,
  createExtensionBlueprintParams,
  createExtensionDataRef,
} from '@backstage/frontend-plugin-api';

import { entityFilterDataRef } from './dataRefs';

export type SubPathResolver<E extends Entity = Entity> = (
  entity: E,
) => string | undefined;

export const subPathDataRef = createExtensionDataRef<SubPathResolver>().with({
  id: 'ipen.dynamic-docs.path',
});

type Params<E extends Entity = Entity> = {
  filter: (entity: Entity) => entity is E;
  subPath: SubPathResolver<E>;
};

/**
 * Defines a dynamic path resolver for the dynamic docs navigation.
 */
export const DynamicDocsNavigationSubPathBlueprint = createExtensionBlueprint({
  attachTo: {
    id: 'dynamic-entity-route:techdocs/dynamic-docs',
    input: 'pathResolver',
  },
  dataRefs: {
    entityFilter: entityFilterDataRef,
    subPath: subPathDataRef,
  },
  defineParams: <E extends Entity>(params: Params<E>) =>
    createExtensionBlueprintParams(params as unknown as Params),
  * factory(params) {
    yield entityFilterDataRef(params.filter);
    yield subPathDataRef(params.subPath);
  },
  kind: 'dynamic-docs-navigation-sub-path',
  output: [subPathDataRef, entityFilterDataRef],
});
